import { AccessTable } from "@/components/access/AccessTable";

export function SettingsAccessPage() {
  return <AccessTable />;
}
